import React from "react";
import {CardFooter} from "@material-tailwind/react";
import {Paginator} from "./paginator";

export function CardFooterPaginator({
                                      active,
                                      setActive,
                                      totalRows,
                                      rowsCount,
                                      setRowsCount,
                                      from,
                                      to
                                    }) {

  return (
    <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
      <Paginator
        active={active}
        setActive={setActive}
        totalRows={totalRows}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        from={from}
        to={to}
      />
    </CardFooter>
  );
}